/**
 * Use this in default case of a switch statement to ensure all cases of a discriminated union has been handled.
 */
export const assertNever = (x: never): never => {
  // oxlint-disable-next-line @typescript-eslint/restrict-template-expressions
  throw new Error(`Unexpected value: ${x}`);
};

export type DistributiveOmit<T, K extends string> = T extends T
  ? Omit<T, K>
  : never;

export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};
